export enum DrawerStateEnum {
  Full = 0,
  Side = 1,
  Closed = 2
}
